import * as commonActionTypes from "../../shared/commonActionTypes";

export const setMatter = (reference, description,isUdModule, udModuleUid, udModuleName, masterProcessName, masterProcessId, id, latestUpdate, latestMilestone) => {
  return {
    type: commonActionTypes.SET_MATTER,
    reference: reference,
    description: description,
    isUdModule: isUdModule,
    udModuleUid: udModuleUid,
    udModuleName: udModuleName,
    masterProcessName: masterProcessName,
    masterProcessId: masterProcessId,
    id: id,
    latestUpdate: latestUpdate, 
    latestMilestone: latestMilestone
  };
};
